import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import InnerBox from '@repo/ui/inner-box'
import Typography from '@repo/ui/typography'
import { useFormContext } from 'react-hook-form'

import { GenderEnum, genderOptionsMapping } from '../../../lib/types/enums/common/gender.enum'
import { InformationRequestInput } from '../../../lib/types/models/information-request/information-request-input'
import { FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledInput from '../../elements/inputs/controlled-input'
import ControlledRadioInput from '../../elements/inputs/controlled-radio-input'

type InformationRequestChildFormProps = {
  required?: boolean
}

const InformationRequestChildForm = ({ required }: InformationRequestChildFormProps) => {
  const form = useFormContext<InformationRequestInput>()

  return (
    <InnerBox title="Information de l'enfant">
      <div className="flex flex-col gap-3 ">
        <div className="flex flex-col gap-1">
          <Typography variant="label" color={tailwindColors.grey.lighter}>
            Genre :
          </Typography>
          <div className="flex gap-5">
            {Object.values(GenderEnum).map((gender) => (
              <FormField
                key={gender}
                control={form.control}
                name="childGender"
                render={({ field }) => {
                  return (
                    <FormItem>
                      <FormControl>
                        <ControlledRadioInput
                          {...field}
                          label={genderOptionsMapping[gender].gender}
                          checked={field.value === gender}
                          onCheck={() => field.onChange(gender)}
                        />
                      </FormControl>
                    </FormItem>
                  )
                }}
              />
            ))}
          </div>
        </div>
        <FormField
          control={form.control}
          name="childLastName"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <ControlledInput {...field} label="NOM de l'enfant" type="text" />
              </FormControl>
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="childFirstName"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <ControlledInput
                  {...field}
                  label="Prénom de l'enfant"
                  type="text"
                  required={required}
                />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
    </InnerBox>
  )
}

export default InformationRequestChildForm
